import React from 'react';
import { MessageSquare, Check } from 'lucide-react';

const WhatsAppConnectionModal = ({
  mobile,
  whatsAppNumber,
  setWhatsAppNumber,
  connectWhatsApp,
  skipWhatsApp
}) => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-green-500 to-green-700 flex items-center justify-center z-50 p-2 sm:p-4 overflow-y-auto">
      <div className="bg-white w-full max-w-md rounded-2xl sm:rounded-3xl p-6 sm:p-8 shadow-2xl my-4 sm:my-8">
        <div className="text-center mb-6 sm:mb-8">
          <div className="w-20 h-20 sm:w-24 sm:h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
            <MessageSquare size={40} className="sm:w-12 sm:h-12 text-green-600" />
          </div>
          <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">
            Connect WhatsApp
          </h2>
          <p className="text-sm sm:text-base text-gray-600 px-2">
            Get instant order updates and exclusive offers on WhatsApp
          </p>
        </div>

        <div className="bg-green-50 border-2 border-green-200 rounded-xl p-3 sm:p-4 mb-4 sm:mb-6">
          <h3 className="font-semibold text-gray-800 mb-2 sm:mb-3 flex items-center gap-2 text-sm sm:text-base">
            <Check size={18} className="sm:w-5 sm:h-5 text-green-600" />
            Benefits of WhatsApp Updates
          </h3>
          <ul className="space-y-1.5 sm:space-y-2 text-xs sm:text-sm text-gray-700">
            <li className="flex items-start gap-2">
              <span className="text-green-600 mt-0.5">•</span>
              <span>Real-time order and delivery notifications</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-600 mt-0.5">•</span>
              <span>Exclusive deals and flash sales alerts</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-600 mt-0.5">•</span>
              <span>Quick customer support via chat</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-600 mt-0.5">•</span>
              <span>Subscription reminders and updates</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-600 mt-0.5">•</span>
              <span>Easy reordering with one tap</span>
            </li>
          </ul>
        </div>
       <div className="mb-4 sm:mb-6">
              <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
                Enter WhatsApp Number
              </label>
              <div className="flex items-center border-2 border-gray-200 rounded-xl px-3 py-2.5 sm:px-4 sm:py-3 focus-within:border-blue-500 transition-all">
                <span className="text-gray-600 font-medium mr-2 text-sm sm:text-base">+91</span>
                <input
                  type="tel"
                  maxLength="10"
                  value={mobile}
                  defaultValue={mobile}
                  onChange={(e) => setWhatsAppNumber(e.target.value.replace(/\D/g, ''))}
                  placeholder="Enter 10-digit number"
                  className="flex-1 outline-none text-gray-800 text-base sm:text-lg"
                />
              </div>
        </div>
        <div className="space-y-2 sm:space-y-3">
          <button
            onClick={connectWhatsApp}
            className="w-full bg-green-600 text-white py-3 sm:py-4 rounded-xl font-semibold flex items-center justify-center gap-2 sm:gap-3 hover:bg-green-700 transition-all text-sm sm:text-base"
          >
            <MessageSquare size={18} className="sm:w-5 sm:h-5" />
            Connect WhatsApp
          </button>

          <button
            onClick={skipWhatsApp}
            className="w-full bg-gray-100 text-gray-700 py-3 sm:py-4 rounded-xl font-semibold hover:bg-gray-200 transition-all text-sm sm:text-base"
          >
            Skip for Now
          </button>
        </div>

        <p className="text-xs text-gray-500 text-center mt-3 sm:mt-4">
          You can enable this later from Settings
        </p>
      </div>
    </div>
  );
};

export default WhatsAppConnectionModal;